import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  title: string;
  subtitle: string;
}
export function PageHero({
  title,
  subtitle
}: PageHeroProps) {
  return <section className="relative pt-40 pb-20 px-4 bg-primary overflow-hidden" data-id="element-213">
      {/* Modern gradient orbs */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-214">
        <div className="absolute -top-1/3 -right-1/4 w-[500px] h-[500px] rounded-full bg-white/5 blur-3xl" data-id="element-215" />
        <div className="absolute -bottom-1/3 -left-1/4 w-[400px] h-[400px] rounded-full bg-accent/10 blur-3xl" data-id="element-216" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-217">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6" data-id="element-218">
          {title}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-xl text-primary-100 text-white/90 max-w-2xl mx-auto" data-id="element-219">
          {subtitle}
        </motion.p>
      </div>
    </section>;
}